import { Box, Link } from '@mui/material';
import { EVENT_LOCATION, useTrackEvent } from '@src/hooks/useTrackEvent';
import React, { useEffect, useState } from 'react';
import AuctionDetails from './auction-details';
import AuctionSummary from './auction-summary';
import BidOnline from './bid-online';
import { EVENT_TITLE } from '@src/enums/event-title-enum';
import { GetAuction_auction } from '@src/types/generated/GetAuction';
import { useMediaQueries } from '@src/hooks/useMediaQueries';
import useStyles from './styles';

type Props = { auction: GetAuction_auction };

const AuctionSummaryWithDetails = ({ auction }: Props) => {
    const [isShowingDetails, setIsShowingDetails] = useState(false);

    const classes = useStyles();
    const { isMediumScreen } = useMediaQueries(true);

    useEffect(() => {
        if (isMediumScreen) {
            setIsShowingDetails(true);
        }
    }, [isMediumScreen]);

    const toggleDetails = () => {
        setIsShowingDetails(!isShowingDetails);
    };

    const trackEvent = useTrackEvent();

    const trackAuctionLocation = () => {
        trackEvent(EVENT_TITLE.AuctionLocationLink, { location: EVENT_LOCATION.AUCTION, objectId: auction.slug });
    };
    const bidOnlineButtonClick = () => {
        trackEvent(EVENT_TITLE.BidOnlineNow, {
            location: EVENT_LOCATION.AUCTION,
            objectId: auction.slug,
        });
    };
    const contactButtonClick = () => {
        trackEvent(EVENT_TITLE.AuctioneerContact, { location: EVENT_LOCATION.AUCTION, objectId: auction.slug });
        window.open(auction.url, '_blank');
    };

    return (
        <>
            <AuctionSummary auction={auction}>
                <div className={classes.bidOnlineContainer}>
                    <BidOnline
                        auction={auction}
                        bidOnlineButtonClick={bidOnlineButtonClick}
                        contactButtonClick={contactButtonClick}
                    />
                </div>
                {isShowingDetails && <AuctionDetails auction={auction} trackAuctionLocation={trackAuctionLocation} />}

                <hr className={classes.fullWidthHr} />

                <Box display='flex' justifyContent='center'>
                    <Link href='#' onClick={toggleDetails} className={classes.showMoreDetailsButton}>
                        {isShowingDetails ? 'Show Less Details' : 'Show More Details'}
                    </Link>
                </Box>
            </AuctionSummary>
        </>
    );
};

export default AuctionSummaryWithDetails;
